<template>
    <v-dialog v-model="dialogState" max-width="1400px">
        <v-card
            :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-6'"
            elevation="0"
        >
            <v-tabs v-model="step" grow center-active>
                <v-tab> Vista Simple </v-tab>
                <v-tab> Histórico </v-tab>
                <!-- <v-tab> Contratos </v-tab> -->
                <v-tab> Notas </v-tab>
                <v-tabs-items class="pt-4" v-model="step">
                    <v-tab-item class="pb-5">
                        <TtForm />
                    </v-tab-item>
                    <v-tab-item class="pb-10">
                        <LogForm />
                    </v-tab-item>
                    <!-- <v-tab-item class="pb-10">
                        <LogContracts />
                    </v-tab-item> -->
                    <v-tab-item class="pb-10">
                        <LogNote />
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-card>
    </v-dialog>
</template>
<script>
import TtForm from './TtForm.vue';
import LogContracts from './LogContracts.vue';
import LogForm from './LogForm.vue';
import LogNote from './LogNote.vue';
// import {mapState} from 'vuex'
export default {
    components: {
        TtForm,
        LogForm,
        LogNote,
        LogContracts,
    },
    data: () => ({
        step: 0,
    }),
    watch: {
        step() {
            // console.log(this.step);
        },
    },
    computed: {
        dialogState: {
            get: function () {
                return this.$store.state.teletrabajo.CompleteViewTtForm.dialog
                    .IsOpen;
            },
            set: function () {
                this.step = 0;
                this.$store.dispatch(
                    'teletrabajo/closeCompleteViewTtFormDialog'
                );
                if (this.$store.state.teletrabajo.TtFormType != 'create')
                    this.$store.dispatch('teletrabajo/setDefaultTtForm');
            },
        },
    },
};
</script>
